import React, { Suspense } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { Flex, Spinner } from "@chakra-ui/react";

import { NavigationBar } from "components/LayoutComponents";
import { ErrorBoundary, NotFoundNotification } from "components/ErrorBoundary";

import { Groups } from "./components/Groups";
import { MainContent } from "./components/MainContent";
import { Breadcrumbs } from "../Breadcrumbs";

const Queues = React.lazy(() => import("../Queues"));
const InitialPage = React.lazy(() => import("../InitialPage"));
const Reservation = React.lazy(() => import("../Reservation/Reservation"));
const ReservationSummary = React.lazy(() => import("../ReservationSummary"));
const EditReservation = React.lazy(
  () => import("../Reservation/EditReservation")
);
const AppointmentConfirmationPage = React.lazy(
  () => import("../TokenablePages/AppointmentConfirmationPage")
);
const CancellationPage = React.lazy(
  () => import("../TokenablePages/CancellationPage")
);
const EditPage = React.lazy(() => import("../TokenablePages/EditPage"));
const RegistrationConfirmationPage = React.lazy(
  () => import("../TokenablePages/RegistrationConfirmationPage")
);
const ResetPasswordPage = React.lazy(
  () => import("../TokenablePages/ResetPasswordPage")
);
const SsoPage = React.lazy(() => import("../Sso/SsoPage"));
const SsoLoginSuccessPage = React.lazy(
  () => import("../Sso/SsoLoginSuccessPage")
);
const RegistrationConfirmationSsoUserPage = React.lazy(
  () => import("../TokenablePages/RegistrationConfirmationSsoUserPage")
);
const ConnectSsoUserPage = React.lazy(
  () => import("../TokenablePages/ConnectSsoUserPage")
);

const CommonRoutes = () => {
  const { pathname } = useLocation();
  return (
    <>
      <NavigationBar>
        <Groups />
      </NavigationBar>
      <Flex flex={1} direction="column">
        <MainContent>
          <ErrorBoundary resetKeys={[pathname]}>
            <Suspense fallback={<Spinner size="xl" />}>
              <Breadcrumbs />
              <Switch>
                <Route
                  exact
                  path="/"
                  render={() => <Redirect to="/e-rezerwacja/default" />}
                />
                <Route
                  exact
                  path="/e-rezerwacja"
                  render={() => <Redirect to="/e-rezerwacja/default" />}
                />
                <Route
                  exact
                  path="/e-rezerwacja/:friendlyUrl"
                  component={InitialPage}
                />
                <Route
                  exact
                  path="/e-rezerwacja/:friendlyUrl/:groupId"
                  component={Queues}
                />
                <Route
                  exact
                  path="/e-rezerwacja/:friendlyUrl/:groupId/rezerwacja/:queueId"
                  component={Reservation}
                />
                <Route
                  exact
                  path="/e-rezerwacja/:friendlyUrl/:groupId/rezerwacja/:queueId/podsumowanie/:appointmentId"
                  component={ReservationSummary}
                />
                <Route
                  exact
                  path="/e-rezerwacja/:friendlyUrl/:groupId/rezerwacja/:queueId/edycja/:appointmentId"
                  component={EditReservation}
                />
                <Route
                  exact
                  path="/e-rezerwacja/:friendlyUrl/potwierdzenie/:tokenId"
                  component={AppointmentConfirmationPage}
                />
                <Route
                  exact
                  path="/e-rezerwacja/:friendlyUrl/anulowanie/:tokenId"
                  component={CancellationPage}
                />
                <Route
                  exact
                  path="/e-rezerwacja/:friendlyUrl/edycja/:tokenId"
                  component={EditPage}
                />
                <Route
                  exact
                  path="/e-rezerwacja/:friendlyUrl/weryfikacja/:tokenId"
                  component={RegistrationConfirmationPage}
                />
                <Route
                  exact
                  path="/e-rezerwacja/:friendlyUrl/zmien-haslo/:tokenId"
                  component={ResetPasswordPage}
                />
                <Route
                  exact
                  path="/e-rezerwacja/:friendlyUrl/powrot-sso/:ssoToken"
                  component={SsoPage}
                />
                <Route
                  exact
                  path="/e-rezerwacja/:friendlyUrl/powrot-sso/:ssoToken/success"
                  component={SsoLoginSuccessPage}
                />
                <Route
                  exact
                  path="/e-rezerwacja/:friendlyUrl/weryfikacja-sso/:ssoToken"
                  component={RegistrationConfirmationSsoUserPage}
                />
                <Route
                  exact
                  path="/e-rezerwacja/:friendlyUrl/powiazanie-sso/:ssoToken"
                  component={ConnectSsoUserPage}
                />
                <Route component={NotFoundNotification} />
              </Switch>
            </Suspense>
          </ErrorBoundary>
        </MainContent>
      </Flex>
    </>
  );
};

export { CommonRoutes };
